<template>
    <div class="row justify-content-center animated fadeInRight">
        <loading v-if="loading" message="Подождите..."></loading>
        <form v-else class="col-lg-6 col-md-8 col-sm-12" v-on:submit.prevent="remindEmail()">
            <div class="card-group mb-0">
                <div class="card p-4">
                    <div class="card-block">
                        <h1>Забыли пароль?</h1>
                        <p class="text-muted mt-2 mb-2">
                            Сбросить пароль используя электронну почту
                            <!--<button class="btn btn-primary btn-sm" @click.prevent="type = 'email'" :class="{ 'btn-secondary': type === 'phone' }">электронну почту</button>-->
                            <!--или-->
                            <!--<button class="btn btn-primary btn-sm" @click.prevent="type = 'phone'" :class="{ 'btn-secondary': type === 'email' }">номер телефона</button>-->
                        </p>
                        <div class="mb-1" v-if="type === 'email'">
                            <div class="input-group" v-bind:class="{ 'has-danger': error || $v.remind.email.$error }">
                                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                <input class="form-control" id="email" type="email" v-model="remind.email" @input="$v.remind.email.$touch()" placeholder="Электронная почта">
                            </div>
                            <small class="help-block text-danger" v-if="$v.remind.email.$error">Адрес электронной почты должен быть валидным</small>
                            <small class="help-block text-danger" v-if="error">Данный адрес электронной почты не найден</small>
                        </div>
                        <div class="mb-1" v-if="type === 'phone'">
                            <div class="input-group" v-bind:class="{ 'has-danger': error }">
                                <span class="input-group-addon">+7</span>
                                <input class="form-control" type="text" v-model="remind.phone" required placeholder="Номер телефона">
                            </div>
                            <small class="help-block text-danger" v-if="error">Данный номер телефона не найден</small>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-5 mb-2">
                                <button type="submit" class="btn btn-primary px-4" :class="{ 'disabled': $v.remind.$invalid }">Сбросить пароль</button>
                            </div>
                            <div class="col-12 col-md-7 mb-2 text-right">
                                <router-link class="btn btn-secondary" :to="{ name: 'Auth' }">Вернуться к странице авторизации</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import { remindEmailUrl } from './../../config'
  import { required, email } from 'vuelidate/lib/validators'
  export default {
    name: 'RemindPassword',
    components: {},
    computed: {
      name () {
        return this.$route.name
      },

      list () {
        return this.$route.matched
      }
    },
    data () {
      return {
        remind: {
          email: null,
          phone: null
        },
        error: false,
        loading: false,
        type: 'email'
      }
    },
    methods: {
      remindEmail () {
        this.error = false
        this.loading = true
        const postData = {
          email: this.remind.email
        }
//        const authUser = {}
        this.$http.post(remindEmailUrl, postData).then((response) => {
          console.log(response)
          this.loading = false
          if (response.status === 200) {
            this.remind.email = null
            this.$router.push({name: 'EmailLinkSend'})
          }
        }, (response) => {
          this.error = true
          this.loading = false
          console.log(response.data)
        })
      }
    },
    validations: {
      remind: {
        email: {
          required,
          email
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemindPassword.vue?263d22c0